export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Followers-Gray-526d10f6f4764c5363decfd561980038.svg";